import React, { useEffect } from 'react';
import darkBanner from "../../images/dark-img.jpg";
import { Col, Container, Row } from 'react-bootstrap';


const PrivacyPolicy = () => {

    useEffect(() => {
        document.title = "Privacy Policy - bharat furnishings";
    }, []);





  return (
    <React.Fragment >

<Container fluid className='px-4 px-lg-5'>
                <Row className='d-flex align-items-center'>
                    <Col lg="12" className='custom_slider inner_banner position-relative mb-5'>

                        <img src={darkBanner} alt="Contact" className='img-fluid w-100' />

                        <div className="position-absolute top-50 start-50 translate-middle ">
                            <h1 className="text-white text-center">Privacy Policy </h1>
    
                           </div>

                    </Col>



                    <Col md="12">

                    <p>Effective Date: 16th October , 2024 </p>

                    <p>At Bharat Furnishings, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information.</p>

<p>
<b>Information We Collect:</b> <br/>
We collect personal information through forms on our website. This may include, but is not limited to, your name, email address, and contact number.</p>

<p>
<b>How We Use Your Information:</b> <br/>
The information we collect is used for marketing purposes, including but not limited to: <br/>
Sending promotional materials <br/>
Informing you about our products and services <br/>
Improving our website and services <br/>
</p>

<p>
<b>Sharing Your Information: </b><br/>
We do not share your personal information with third parties without your consent, except as required by law.        </p>

<p>
<b>Your Rights:</b><br/>
You have the right to access, correct, or delete your personal information. If you wish to exercise these rights, please contact us using the information below.
</p>

<p>
<b> Contact Us:</b><br/>
For any questions or concerns regarding your privacy, please contact us at:<br/>
Phone: 02261456000<br/>
Email: <a href="mailto:info@bharatfurnishings.com"  rel='noreferrer'> <b>info@bharatfurnishings.com </b></a>
</p>

<p>
<b> Address: </b><br/>
Bharat Furnishings, <br/>
India House, Kemps Corner, Cumballa Hill, <br/>
Opposite Om chambers, <br/>
Mumbai - 400036.

</p>

<p>
    <b>Changes to This Policy</b><br/>
    We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date
</p>


                    </Col>










                    </Row>


                    </Container>
















    </React.Fragment>
  )
}

export default PrivacyPolicy
